module.exports = __webpack_public_path__ + "static/media/sendandreceive.1cda7d52.svg";